const exampleHeadings = [
  {
    name: "Category",
    key: "name"
  },
  {
    name: "Cost",
    key: "cost"
  },
  {
    name: "Percent",
    key: "percent"
  }
]

const exampleData = [
  {name: "Rent", cost: 1000, percent: 33},
  {name: "Food", cost: 300, percent: 10},
  {name: "Transportation", cost: 100, percent: 3},
  {name: "Entertainment", cost: 50, percent: 2},
  {name: "Health", cost: 50, percent: 2},
  {name: "Miscellaneous", cost: 50, percent: 2}
]

export default function AccessibilityTable({headings, data, label}) {
  if (!headings) {
    headings = exampleHeadings
  }

  if (!data) {
    data = exampleData
  }

  if (!label) {
    label = "Default table label"
  }

  return (
    <div className="sr-only" role="region" aria-live="polite" aria-relevant="all">
      <table role="table">
        <caption>{label}</caption>
        <thead>
          <tr>
            {headings.map((heading) => (
              <th key={heading.key} scope="col">
                {heading.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {headings.map((heading, index) => (
                <td key={heading.key} role={index === 0 ? "rowheader" : "cell"}>
                  {row[heading.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
